export default __webpack_public_path__ + "static/apple-en-4b7b6ed3faa2878be493ce3886a8766f.png";